import { gql } from '@apollo/client';

export const CRM_CAMPAIGN_FIELDS = `
    _id
    name
    audienceId
    templateId
    subject
    templateType
    design
    bodyHtml
    status
    scheduledAt
    sentAt
    stats {
        recipients
        sent
        delivered
        opened
        clicked
        bounced
        failed
        skipped
    }
    createdAt
    updatedAt
`;

export const LIST_CRM_CAMPAIGNS = gql`
    query ListCrmCampaigns {
        listCrmCampaigns {
            ${CRM_CAMPAIGN_FIELDS}
        }
    }
`;

export const GET_CRM_CAMPAIGN = gql`
    query GetCrmCampaign($id: String!) {
        getCrmCampaign(id: $id) {
            ${CRM_CAMPAIGN_FIELDS}
        }
    }
`;

export const GET_CRM_CAMPAIGN_RECIPIENTS = gql`
    query GetCrmCampaignRecipients($campaignId: String!) {
        getCrmCampaignRecipients(campaignId: $campaignId) {
            email
            status
            opened
            openedAt
            clicked
            clickedAt
            outcomeReason
            sentAt
        }
    }
`;
